export default __webpack_public_path__ + "static/media/Snd2.8154fb31.mp3";